module.exports = __webpack_public_path__ + "img/scan.b2ce2b72.jpg";